import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { ICustomerTemplate } from "@/interfaces/customer-template.interface";
import messageTemplateService from "@/services/message-template.service";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination, RequestsBaseReturn } from "@/types/requests.types";

export type UseGetMessageTemplatesProps = RequestPagination & {
  filter?: IFilter<ICustomerTemplate>[];
};

export type UseGetMessageTemplatesReturn = RequestsBaseReturn<
  PaginatedResponse<ICustomerTemplate> | null
>;

const useGetMessageTemplates = ({
  pageNumber,
  pageSize,
  filter = [],
}: UseGetMessageTemplatesProps): UseGetMessageTemplatesReturn => {
  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<PaginatedResponse<ICustomerTemplate>, Error>(
    `${SWR_KEYS.getMessageTemplates}-${pageNumber}-${pageSize}-${JSON.stringify(filter)}`,
    () => messageTemplateService.filter(filter, { pageNumber, pageSize }),
    { revalidateOnFocus: false }
  );

  return { data, isLoading, error };
};

export default useGetMessageTemplates;
